import SeedRandom from 'seed-random';

export type Seed = string;
export type Generator = () => number;

export class Rng {
    public static removeGlobal(seed: string) {
        this.generators.delete(seed);
    }

    public static clearGlobals() {
        this.generators.clear();
    }

    public static hasGlobal(seed: string) {
        return this.generators.has(seed);
    }

    private static generators = new Map<string, Generator>();

    private readonly generator: Generator;

    constructor(seed: Seed, global?: boolean) {
        // @ts-ignore ..import has changed for testing purposes may need to change back for this?
        this.generator = SeedRandom(seed);
        if (global) {
            const generators = Rng.generators;
            if (!generators.has(seed)) {
                generators.set(seed, this.generator);
            }
            this.generator = generators.get(seed);
        }
    }

    public generate(): number {
        return this.generator();
    }
}
